import React from 'react'

import { formatCurrency } from 'utils/formatters'
import { padLeft } from 'utils'

import Card from 'common/Card'
import ReactTable from 'common/ReactTable'

import InvoiceDetail from './InvoiceDetail'

export default ({ resource, purchaseOrderItem, caseCurrency }) => {
  const { po, totals, salesInvoices } = purchaseOrderItem
  const siItems = salesInvoices || []
  const poLines = po.lines

  const columns = React.useMemo(
    () => [
      {
        Header: `${resource.PO} #`,
        accessor: 'poIndex',
        headerClassName: 'text-muted',
        width: 100,
        Cell: ({ value, row }) =>
          row.isCreditNotes ? (
            ''
          ) : (
            <span title={value} className="word-break-break-word white-space-normal">
              {`${padLeft(value, 1)}-${padLeft(row.poLineIndex, 1)}`}
            </span>
          ),
      },
      {
        Header: resource.Description,
        accessor: 'description',
        headerClassName: 'col',
        className: 'col',
        footerClassName: 'col text-end fw-bold',
        Cell: ({ value, row }) =>
          row.isCreditNotes ? (
            <em className="text-muted">{resource.CreditNotes}</em>
          ) : (
            <span title={value} className="word-break-break-word white-space-normal">
              {value}
            </span>
          ),
        Footer: () => `${resource.Total}:`,
      },
      {
        Header: resource.PoAmount,
        accessor: 'poLineSubTotal.value',
        headerClassName: 'col-2 text-end',
        className: 'col-2 border-left text-end border-start',
        footerClassName: 'col-2 border-left text-end fw-bold border-start',
        Cell: ({ value }) => <span>{value ? formatCurrency(value, undefined, caseCurrency.currencySymbol) : '-'}</span>,
        Footer: () => formatCurrency(totals.poTotal.value, undefined, caseCurrency.currencySymbol),
      },
      {
        Header: resource.SiAmount,
        accessor: 'siLineSubTotal.value',
        headerClassName: 'col-2 text-end',
        className: 'col-2 border-left text-end border-start',
        footerClassName: 'col-2 border-left text-end fw-bold border-start',
        Cell: ({ value, row }) =>
          row.isCreditNotes ? (
            <span>{totals.scnTotal ? formatCurrency(totals.scnTotal.value, undefined, caseCurrency.currencySymbol) : '-'}</span>
          ) : (
            <span>{value ? formatCurrency(value, undefined, caseCurrency.currencySymbol) : '-'}</span>
          ),
        Footer: () => formatCurrency(totals.siTotal.value, undefined, caseCurrency.currencySymbol),
      },
    ],
    [resource, totals]
  )

  React.useEffect(() => {
    poLines.push({ isCreditNotes: true })
  }, [])

  return (
    <React.Fragment>
      <Card
        outline
        title={
          <div className="mb-lg-0 mb-1 white-space-break-spaces text-lg-start text-center">
            {resource.InvoiceTotalsFor} <strong>{`${resource.PO} #${padLeft(po.poIndex, 1)}`} </strong>
          </div>
        }
        titleClassName="white-space-nowrap flex-lg-row flex-column"
        className="invoice-order-block-item margin-bot-20"
      >
        <ReactTable columns={columns} data={poLines} showFooter responsive />
      </Card>
      {!!siItems.length && <InvoiceDetail resource={resource} siItems={siItems} caseCurrency={caseCurrency} />}
    </React.Fragment>
  )
}
